import { Branch } from 'inventory-web'
import {
	EuiFieldText,
	EuiFormRow,
} from '@equipmentshare/ds2'
import BranchPicker from 'components/BranchPicker'

export type InventoryLocationFormProps = {
	formState: InventoryLocationFormState,
	setFormState: ( formState: InventoryLocationFormState ) => void,
	hasBranch?: boolean,
}

export type InventoryLocationFormState = {
	branch?: Branch,
	name: string,
	validation: {
		branch: {
			isInvalid: boolean,
			error?: string,
		},
		name: {
			isInvalid: boolean,
			error?: string,
		},
	},
}

export default function InventoryLocationForm( { formState, setFormState, hasBranch }: InventoryLocationFormProps ) {
	const onChangeName = ( event: React.ChangeEvent<HTMLInputElement> ) => setFormState( {
		...formState,
		name: event.currentTarget.value,
		validation: {
			...formState.validation,
			name: { isInvalid: false },
		},
	} )

	const onChangeBranch = ( _?: number, branch?: Branch ) => setFormState( {
		...formState,
		branch,
		validation: {
			...formState.validation,
			branch: { isInvalid: false },
		}
	} )

	return (
		<>
			{ hasBranch && (
				<BranchPicker
					label="Select Branch"
					selectedBranch={formState.branch}
					onChange={onChangeBranch}
					formRowProps={formState.validation.branch}
				/>
			) }
			<EuiFormRow
				label="Store Name"
				{...formState.validation.name}
			>
				<EuiFieldText
					value={formState.name}
					isInvalid={formState.validation.name.isInvalid}
					onChange={onChangeName}
				/>
			</EuiFormRow>
		</>
	)
}
